import { EventEmitter } from '@angular/core';
import { HttpClient } from '../shared/http-client';
import 'rxjs/add/operator/map';
var ClienteService = /** @class */ (function () {
    function ClienteService(httpClient) {
        this.httpClient = httpClient;
        this.clientesUsuario = [];
        this.clienteEmitter = new EventEmitter();
    }
    ClienteService.prototype.setCliente = function (cliente) {
        this.clienteActual = cliente;
        this.clienteEmitter.emit(cliente);
    };
    ClienteService.prototype.getCliente = function () {
        return this.clienteActual;
    };
    ClienteService.prototype.listado = function (pagina, cantidadPorPagina, query) {
        // get users from api
        return this.httpClient.get("/clientes/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina + "&query=" + query)
            .map(function (response) {
            return response.json();
        });
    };
    ClienteService.prototype.importarCtaCte = function (file, datos, comprobantes) {
        var postData = { datos: JSON.stringify(datos) };
        return comprobantes == null
            ? this.httpClient.postWithFile("/clientes/importar", postData, { file: file, name: 'zip' })
            : this.httpClient.postWithFiles("/clientes/importar", postData, [{ file: comprobantes, name: 'comprobantes' }, { file: file, name: 'zip' }]);
    };
    ClienteService.prototype.obtenerHistorica = function (clienteId, pagina, cantidadPorPagina) {
        return this.httpClient.get("/clientes/" + clienteId + "/ctacte/historica/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina)
            .map(function (response) {
            return response.json();
        });
    };
    ClienteService.prototype.obtenerAplicada = function (clienteId, pagina, cantidadPorPagina) {
        return this.httpClient.get("/clientes/" + clienteId + "/ctacte/aplicada/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina)
            .map(function (response) {
            return response.json();
        });
    };
    ClienteService.prototype.obtenerSaldo = function (clienteId) {
        return this.httpClient.get("/clientes/" + clienteId + "/ctacte/saldo")
            .map(function (response) {
            return response.json();
        });
    };
    ClienteService.prototype.obtenerComprobante = function (clienteId, comprobante) {
        return this.httpClient.get("/clientes/" + clienteId + "/movimientos/" + comprobante + "/descargar", true);
    };
    ClienteService.prototype.guardar = function (cliente) {
        return this.httpClient.put('/clientes/', cliente);
    };
    ClienteService.prototype.reenviarRegistracion = function (id) {
        return this.httpClient.post("/clientes/" + id + "/reenviar/registracion", null);
    };
    ClienteService.prototype.obtenerEmail = function (id) {
        return this.httpClient.get("/clientes/" + id + "/email/registracion");
    };
    ClienteService.prototype.eliminar = function (id) {
        return this.httpClient.delete("/clientes/" + id);
    };
    ClienteService.ctorParameters = function () { return [{ type: HttpClient }]; };
    return ClienteService;
}());
export { ClienteService };
//# sourceMappingURL=cliente.service.js.map


// WEBPACK FOOTER //
// cliente.service.js